import withAuthGuard from '@hocs/withAuthGuard';

import VerificationPage from './VerificationPage';

export default withAuthGuard()(VerificationPage);
